<script setup>
import ButtonApp from '@/components/ButtonApp.vue';
import MessageApp from '@/components/MessageApp.vue';
import { vAutofocus } from '@/directives/vAutofocus';
import { props, setCookie, UserService, validUserLogged } from '@/modules/user/store';
import { ref } from 'vue';

validUserLogged();

const addButton = ref(null);
const statusMessage = ref(null);

function resetButtonAdd() {
  addButton.value.unlock();
}

async function loginAccount() {
  addButton.value.lock();

  await UserService.login(props.value.user)
    .then((res) => {
      setCookie(res.sessionId);
      window.location.href = '/welcome';
      resetButtonAdd();
    })
    .catch((error) => {
      console.log(error);
      setCookie(null, '0s');
      statusMessage.value.setMessage(error);
      resetButtonAdd();
    });
}
</script>

<template>
  <div class="blank-page">
    <div class="content-wrapper">
      <div class="content-body">
        <div class="auth-wrapper auth-cover">
          <div class="auth-inner row m-0">

            <a class="brand-logo" href="/">
              <img src="/img/logo.png" class="m-2" width="120" alt="vr pay" />
            </a>
            <div class="d-none d-lg-flex col-lg-8 align-items-center p-5">
              <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
                <img class="img-fluid" src="/assets/img/login.svg" alt="Login" />
              </div>
            </div>
            <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
              <div class="col-12 col-sm-8 col-md-12 col-lg-12 px-xl-2 mx-auto">
                <h2 class="card-title fw-bold mb-1">Seja bem-vindo 👋</h2>
                <p class="card-text mb-2">VR Pay sua solução financeira!</p>
                <div class="mb-1">
                  <label class="form-label" for="register-email">E-mail</label>
                  <input class="form-control" v-autofocus id="email" v-model="props.user.email" type="text" name="email" placeholder="Informe seu e-mail" />
                </div>
                <div class="mb-1">
                  <div class="d-flex justify-content-between">
                    <label class="form-label" for="register-password">Senha</label><a href="/user/forgot"><small>Esqueceu a senha?</small></a>
                  </div>
                  <input class="form-control" id="password" v-model="props.user.password" type="password" name="password" placeholder="Informe sua senha" v-on:keyup.enter="loginAccount()" />
                </div>
                <ButtonApp ref="addButton" @click="loginAccount()" title="Acessar conta" class="w-100" />
                <MessageApp ref="statusMessage" showClose @hideAlert="statusMessage.hideMessage()" />
                <p class="text-center mt-2">
                  <span>Não tem uma conta ?</span><a href="/user/add"><span>&nbsp;Crie uma agora 🚀</span></a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.auth-wrapper {
  display: flex;
  flex-basis: 100%;
  min-height: 100vh;
  min-height: calc(var(--vh, 1vh) * 100);
  width: 100%;
}

.auth-wrapper.auth-cover .brand-logo {
  position: absolute;
  top: 2rem;
  left: 2rem;
  margin: 0;
  z-index: 1;
  justify-content: unset;
}

.auth-wrapper .brand-logo {
  display: flex;
  justify-content: center;
  margin: 1rem 0 2rem 0;
}

.auth-wrapper .auth-bg {
  background-color: #fff;
}

.auth-wrapper.auth-cover {
  align-items: flex-start;
}

.auth-wrapper.auth-cover .auth-inner {
  height: 100vh;
  overflow-y: auto;
  height: calc(var(--vh, 1vh) * 100);
}

.auth-wrapper .auth-inner {
  width: 100%;
}

@media (max-height: 825px) and (max-width: 991.98px) {
  .dark-layout .auth-wrapper .auth-inner {
    background-color: #283046; }
  .auth-wrapper .auth-bg {
    padding-top: 3rem;
    margin: auto 0; }
  .auth-wrapper .auth-inner {
    background-color: #fff; }
  .auth-wrapper.auth-cover .auth-inner {
    padding-bottom: 1rem;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap; }
  .auth-wrapper.auth-cover .brand-logo {
    position: relative;
    left: 0;
    padding-left: 1.5rem; } }
</style>
